import VueRouter from 'vue-router'
import Overview from '@/components/Overview.vue'
import Projects from '@/components/Projects.vue'
import SignedIn from '@/components/SignedIn.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
import OverviewDemo from '@/components/OverviewDemo.vue'
import store from "@/store/store.js"
import API from '@/resources/API.js'
import API_demo from '@/resources/API_demo.js';
var qs = require('qs');

const routes = [{
        path: '/overview/:state_id',
        name: 'overvieww',
        props: true,
        component: Overview
    },
    {
        path: '/signedin/',
        name: 'signedin',
        props: true,
        component: SignedIn
    },
    {
        path: '/projects/',
        name: 'projects',
        component: Projects
    },
    {
        path: '/404/',
        name: '404',
        component: PageNotFound
    },
    {
        path: '/demo/:state_id',
        name: 'demo',
        component: OverviewDemo
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    // set custom query resolver
    parseQuery(query) {
        return qs.parse(query, {
            decoder(str, decoder, charset) {
                // const strWithoutPlus = str.replace(/\+/g, ' ');
                const strWithPlus = str
                if (charset === 'iso-8859-1') {
                    // unescape never throws, no try...catch needed:
                    return strWithPlus.replace(/%[0-9a-f]{2}/gi, unescape);
                }

                // if (/^(\d+|\d*\.\d+)$/.test(str)) {
                //   return parseFloat(str)
                // }

                const keywords = {
                    true: true,
                    false: false,
                    null: null,
                    undefined,
                }
                if (str in keywords) {
                    return keywords[str]
                }

                // utf-8
                try {
                    return decodeURIComponent(strWithPlus);
                } catch (e) {
                    return strWithPlus;
                }
            }
        });
    },
    stringifyQuery(query) {
        var result = qs.stringify(query, {
            encode: false
        });
        return result ? ('?' + result) : '';
    }
})

router.beforeEach((to, from, next) => {
    if (to.path === "/demo" || to.path === "/demo/") {
        next('/demo/default')
        return
    } else if (!store.state.metaIsPresent && to.path.startsWith("/demo")) {
        API_demo.GetMeta()
            .then(response => {
                console.log(response);
                store.commit('setMeta', JSON.parse(JSON.stringify(response.data)))
                next()
            })
            .catch(error => {
                console.log(error);
            })
    } else if (to.path === "/overview" || to.path === "/overview/") {
        next('/overview/default')
        return
    } else if (!store.state.metaIsPresent && to.path.startsWith("/overview")) {
        API.GetMeta()
            .then(response => {
                console.log(response);
                store.commit('setMeta', JSON.parse(JSON.stringify(response.data)))
                next()
            })
            .catch(error => {
                console.log(error);
            })
    } else {
        next()
    }
})

export default router